/**
 * 관리자 복귀 알약 ($j.F.Mobile.ProxyBar)
 *
 * 모바일관리자(/ma)에서 회원 앱으로 대리진입한 CS 가 **돌아올 유일한 출구**다.
 * 대리 중엔 세션 회원이 남(회원)이라 서랍의 '관리자' 항목(is_mobile_admin)이 사라지고,
 * 앱 웹뷰엔 주소창도 없어 /ma 로 돌아갈 길이 이 버튼밖에 없다.
 *
 * 노출 판정은 G5.maProxyBack(= ma_proxy_back(), 세션 ma_proxy_back) 하나다.
 * 데스크탑 대리로그인(/adm 아이프레임)에는 이 표식이 없어 뜨지 않는다 — 그쪽은 프레임을 닫으면 된다.
 *
 * 호출: 모바일 사이트 부트스트랩(Sites/Mobile/Bootstrap)에서 매 페이지 start(). 대리 중이 아니면 no-op.
 * 복귀 처리(회원세션 되돌리기 + /ma 화면 복귀)는 서버 MobileAdmin\ProxyController@back 이 한다.
 *
 * isProxy() 는 복귀바 노출 판정 전용이다 — '/ma 로 들어왔나'(경로 축)를 본다.
 * 회원 귀속 동작을 막는 판정은 서버 is_admin_proxy() = G5.isAdminProxy 다. (.ai/proxy-login.md §4-4)
 *
 * 모양·자리·끌어옮기기는 공용 $j.Ui.EdgeTab 이 맡는다 (AI 발주 버튼과 같은 규격).
 * 다만 이 알약만 라벨을 접지 않는다(collapse:false) — 라벨에 **누구 계정인지**가 들어 있다.
 */
const BAR_ID = 'pxb-bar';

export default class ProxyBar {
    /** 대리진입(/ma) 중인가 — 화면 밖(AppBridge.js · Baljoo.js)에서도 쓰는 판정 */
    isProxy = () => {
        return (typeof G5 !== 'undefined') && parseInt(G5.maProxyBack, 10) > 0;
    };

    /** 대리 중이면 알약을 띄운다. 아니면 아무것도 하지 않는다. */
    start = () => {
        if (!this.isProxy()) return;
        if (document.getElementById(BAR_ID)) return;   // 같은 페이지 재호출 방어

        const who = this._who();

        const $bar = $(`<button type="button" id="${BAR_ID}" class="jb-edge-tab jb-edge-tab--proxy"
                aria-label="${who ? `${who} 계정으로 대리진입 중 — 눌러서 관리자 복귀` : '관리자 복귀'} (끌어서 옮길 수 있음)">
                <i class="fas fa-user-shield" aria-hidden="true"></i><em></em>
            </button>`);
        // 회원명은 DB 값이라 템플릿에 끼워넣지 않고 텍스트로 넣는다(따옴표·꺾쇠 포함 가능)
        $bar.find('em').text(who ? `${who} ▸ 복귀` : '관리자 복귀');
        $('body').append($bar);

        // collapse:false — 지금 **누구 계정에 들어와 있는지**는 접어서 감출 정보가 아니다.
        // 이름이 안 보이면 CS 가 남의 계정인 줄 모르고 조작하게 된다(그게 이 알약이 있는 이유다).
        $j.Ui.EdgeTab.attach($bar[0], { key: 'proxy', collapse: false, onTap: this._back });
    };

    /** 지금 들어와 있는 회원의 표시명 — 없으면 빈 문자열(라벨을 '관리자 복귀'로 되돌린다) */
    _who = () => {
        if (typeof MEMBER === 'undefined' || !MEMBER) return '';
        return String(MEMBER['mem_name'] || MEMBER['real_name'] || '').trim();
    };

    /**
     * 복귀. 대리진입도 location.replace 로 왔으므로 되돌아갈 때도 히스토리를 남기지 않는다
     * (남기면 안드로이드 백버튼이 남의 계정 화면으로 되돌아간다).
     */
    _back = () => {
        location.replace('/ma/proxy/back');
    };
}
